import Vue from 'vue'
import Router from 'vue-router'
import Vuetify from 'vuetify'
import money from '../lib/v-money'
import xlsx from 'xlsx'

import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Inicio from '@/components/Inicio'
import Ingresar from '@/components/Ingresar'
import Ficha from '@/components/Ficha'
import FichaInscripcion from '@/components/FichaInscripcion'
import Usuarios from '@/components/Usuarios'
import Colegio from '@/components/Colegio'
import Colegios from '@/components/Colegios'
import Libres from '@/components/Libres'
import Delegaciones from '@/components/Delegaciones'
import Pago from '@/components/Pago'
import Pagos from '@/components/Pagos'
import Credenciales from '@/components/Credenciales'
import Inscritos from '@/components/Inscritos'
import Resultados from '@/components/Resultados'
import Configuracion from '@/components/Configuracion'
import Sedes from '@/components/Sedes'
import Resultado from '@/components/Resultado'
import Reportes from '@/components/Reportes'

Vue.component('cambiar-clave', require('@/components/CambiarClave').default)
// Vue.component('venta-producto', require('@/components/VentaProducto').default)
// Vue.component('venta-seleccionar-producto', require('@/components/VentaSeleccionarProducto').default)
Vue.use(Router)
Vue.use(Vuetify)
Vue.use(money)
Vue.use(xlsx)

if (localStorage.getItem('tokenId') === null) {
  localStorage.setItem('tokenId', '')
}
if (localStorage.getItem('local') === null) {
  localStorage.setItem('local', '')
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Inicio',
      component: Inicio
    },
    {
      path: '/Ingresar',
      name: 'Ingresar',
      component: Ingresar
    },
    {
      path: '/Ingresar/:tipoIngreso',
      name: 'IngresarParam',
      component: Ingresar
    },
    {
      path: '/Ficha',
      name: 'Ficha',
      component: Ficha
    },
    {
      path: '/Pago',
      name: 'Pago',
      component: Pago
    },
    {
      path: '/Pago/:idAlumno',
      name: 'PagoParam',
      component: Pago
    },
    {
      path: '/Pagos',
      name: 'Pagos',
      component: Pagos
    },
    {
      path: '/FichaInscripcion',
      name: 'FichaInscripcion',
      component: FichaInscripcion
    },
    {
      path: '/Usuarios',
      name: 'Usuarios',
      component: Usuarios
    },
    {
      path: '/Colegio',
      name: 'Colegio',
      component: Colegio
    },
    {
      path: '/Sedes',
      name: 'Sedes',
      component: Sedes
    },
    {
      path: '/Colegios',
      name: 'Colegios',
      component: Colegios
    },
    {
      path: '/Estudiantes',
      name: 'Alumnos',
      component: Libres
    },
    {
      path: '/Delegaciones',
      name: 'Delegaciones',
      component: Delegaciones
    },
    {
      path: '/Credenciales',
      name: 'Credenciales',
      component: Credenciales
    },
    {
      path: '/Credenciales/:idAlumno',
      name: 'CredencialesParam',
      component: Credenciales
    },
    {
      path: '/Inscritos',
      name: 'Inscritos',
      component: Inscritos
    },
    {
      path: '/Resultados',
      name: 'Resultados',
      component: Resultados
    },
    {
      path: '/Configuracion',
      name: 'Configuracion',
      component: Configuracion
    },
    {
      path: '/Resultado',
      name: 'Resultado',
      component: Resultado
    },
    {
      path: '/Reportes',
      name: 'Reportes',
      component: Reportes
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js